import { Badge, Button, Dropdown, MenuProps, Skeleton, Space } from 'antd';
import { FC, memo } from 'react';
import { PeopleFill } from 'react-bootstrap-icons';

import { AppMessage } from '@/common/components';
import { useAuthState } from '@/common/hooks';

import { UserPosition } from '@/modules/Users';

export const TeamProfileDropdown: FC = memo(() => {
  const { sessionUser, isAuthed, changeCurrentTeamId } = useAuthState();
  const appMessageApi = AppMessage.useControls();

  if (!isAuthed || !sessionUser) {
    return (
      <div>
        <Space size="small">
          <Skeleton.Input size="default" />
        </Space>
      </div>
    );
  }

  const { teams, currentTeamId } = sessionUser;

  const items: NonNullable<MenuProps['items']> = (
    sessionUser.position === UserPosition.Administrator
      ? ([
          {
            key: 'null',
            onClick: () => handleChangeTeam(null),
            label: (
              <Space>
                <i>(Команда)</i>
                {sessionUser.currentTeamId === null && <Badge dot />}
              </Space>
            ),
          },
        ] as NonNullable<MenuProps['items']>)
      : []
  ).concat(
    teams.map((team) => ({
      key: team.id,
      onClick: () => handleChangeTeam(team.id),
      label: (
        <Space style={{ width: '100%' }}>
          <PeopleFill />
          <span>{team.name}</span>
          {team.id === sessionUser.currentTeamId && <Badge dot />}
        </Space>
      ),
    })),
  );

  const handleChangeTeam = (teamId: string | null) => {
    if (teamId !== currentTeamId) {
      changeCurrentTeamId(teamId);
    }
  };

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottom">
      <Button type="primary" color="blue" variant="solid">
        <PeopleFill />
        {currentTeamId ? teams.find((team) => team.id === currentTeamId)?.name : <i>(Команда)</i>}
      </Button>
    </Dropdown>
  );
});
